import { 
    RESULT_TRACE_GET_REQUEST, RESULT_TRACE_GET_SUCCESS, RESULT_TRACE_GET_ERROR, 
    RESULT_TRACE_GET_BY_KEY_REQUEST, RESULT_TRACE_GET_BY_KEY_SUCCESS, RESULT_TRACE_GET_BY_KEY_ERROR, 
    RESULT_TRACE_ADD_REQUEST, RESULT_TRACE_ADD_SUCCESS, RESULT_TRACE_ADD_ERROR, 
    RESULT_TRACE_EDIT_REQUEST, RESULT_TRACE_EDIT_SUCCESS, RESULT_TRACE_EDIT_ERROR, 
    RESULT_TRACE_DELETE_REQUEST, RESULT_TRACE_DELETE_SUCCESS, RESULT_TRACE_DELETE_ERROR
} from "../constants/resultTraceConstants";

const initialState = {
    resultTraces: [],
    resultTrace: {},
    loading: false,
    success: null,
    error: null,
    resultTraceRequestedCount: 0,
};

export const resultTraceReducer = (state = initialState, action) => {
    switch (action.type)     {
        case RESULT_TRACE_GET_REQUEST:
            return {
                ...state,
                resultTraceRequestedCount: ++state.resultTraceRequestedCount,
                loading: true,
            };
        case RESULT_TRACE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                resultTraces: action.payload,
                success: true,
            };
        case RESULT_TRACE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case RESULT_TRACE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case RESULT_TRACE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                resultTrace: action.payload,
                success: true,
            };
        case RESULT_TRACE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case RESULT_TRACE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case RESULT_TRACE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case RESULT_TRACE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case RESULT_TRACE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case RESULT_TRACE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case RESULT_TRACE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case RESULT_TRACE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case RESULT_TRACE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case RESULT_TRACE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
